import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { CRP } from "./content";

const POINTS = [
  "Pós-graduanda em TCC aplicada à infância e adolescência",
  "Facilitadora da comunicação entre pais e adolescentes",
  "Atendimento on-line para adolescentes e adultos",
];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <section id="sobre" ref={ref} data-testid="about-section" className="relative py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5 relative">
          <div className="relative aspect-[3/4] w-[85%] max-w-sm mx-auto rounded-[999px] overflow-hidden bg-mint">
            <motion.div style={{ y }} className="absolute -inset-y-[14%] inset-x-0">
              <img src="/img/ana-sobre.webp" alt="Ana Falaschi, psicóloga" className="w-full h-full object-cover object-[50%_30%]" />
            </motion.div>
          </div>
          <div className="absolute -bottom-6 right-2 sm:right-10 rounded-full bg-butter px-6 py-4 shadow-lg rotate-[-4deg]">
            <p className="font-display text-ink text-lg">Psicóloga</p>
            <p data-testid="about-crp" className="text-xs tracking-[0.18em] text-ink/70 uppercase">{CRP}</p>
          </div>
        </Reveal>
        <div className="lg:col-span-7">
          <Reveal><Eyebrow>Sobre mim</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.05] tracking-tight">
              Olá, sou a Ana. <span className="italic text-sage">Cada pessoa carrega uma história</span> que merece ser ouvida.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-base sm:text-lg text-ink/75 leading-relaxed max-w-2xl">
              Acredito que a adolescência é o presente em transformação — não uma fase a ser apenas atravessada. No processo terapêutico, entender o que você sente é o primeiro passo para transformar como você vive.
            </p>
          </Reveal>
          <ul className="mt-10 border-t border-sage/15">
            {POINTS.map((p, i) => (
              <Reveal key={p} delay={0.25 + i * 0.08}>
                <li className="group flex items-center gap-5 py-5 border-b border-sage/15">
                  <span className="font-display italic text-clay text-xl w-8">0{i + 1}</span>
                  <span className="text-ink text-base sm:text-lg transition-transform duration-500 group-hover:translate-x-2">{p}</span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
